<template>
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5547 8.44434L16.6101 3.38891M16.9221 6.8888L16.995 3.79602C17.0038 3.42154 17.0083 3.23429 16.8934 3.11715C16.7785 3 16.5905 3 16.2145 3H13.1102"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.44428 8.44437L3.38885 3.38894M6.8888 3H3.77776C3.41112 3 3.2278 3 3.1139 3.1139C3 3.2278 3 3.41112 3 3.77776V6.88879"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.4443 11.5547L3.38886 16.6101M3 13.1102V16.2212C3 16.5879 3 16.7712 3.1139 16.8851C3.2278 16.999 3.41112 16.999 3.77776 16.999H6.88879"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.5547 11.5547L16.6101 16.6101M13.1102 16.9989H16.2213C16.5879 16.9989 16.7712 16.9989 16.8851 16.885C16.999 16.7711 16.999 16.5878 16.999 16.2212V13.1101"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
